export const ACTIVATE_MFA_REQUEST = 'ACTIVATE_MFA_REQUEST';
export const ACTIVATE_MFA_REQUEST_FAILURE = 'ACTIVATE_MFA_REQUEST_FAILURE';
export const ACTIVATE_MFA_REQUEST_SUCCESS = 'ACTIVATE_MFA_REQUEST_SUCCESS';

export const DEACTIVATE_MFA_REQUEST = 'DEACTIVATE_MFA_REQUEST';
export const DEACTIVATE_MFA_REQUEST_FAILURE = 'DEACTIVATE_MFA_REQUEST_FAILURE';
export const DEACTIVATE_MFA_REQUEST_SUCCESS = 'DEACTIVATE_MFA_REQUEST_SUCCESS';

export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';
export const FORGOT_PASSWORD_REQUEST_FAILURE = 'FORGOT_PASSWORD_REQUEST_FAILURE';
export const FORGOT_PASSWORD_REQUEST_SUCCESS = 'FORGOT_PASSWORD_REQUEST_SUCCESS';

export const GET_USER_REQUEST = 'GET_USER_REQUEST';
export const GET_USER_REQUEST_FAILURE = 'GET_USER_REQUEST_FAILURE';
export const GET_USER_REQUEST_SUCCESS = 'GET_USER_REQUEST_SUCCESS';

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_REQUEST_FAILURE = 'LOGIN_REQUEST_FAILURE';
export const LOGIN_REQUEST_SUCCESS = 'LOGIN_REQUEST_SUCCESS';

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_REQUEST_FAILURE = 'LOGOUT_REQUEST_FAILURE';
export const LOGOUT_REQUEST_SUCCESS = 'LOGOUT_REQUEST_SUCCESS';

export const PROTECTION_PWD_REQUEST = 'PROTECTION_PWD_REQUEST';
export const PROTECTION_PWD_REQUEST_FAILURE = 'PROTECTION_PWD_REQUEST_FAILURE';
export const PROTECTION_PWD_REQUEST_SUCCESS = 'PROTECTION_PWD_REQUEST_SUCCESS';

export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_REQUEST_FAILURE = 'REGISTER_REQUEST_FAILURE';
export const REGISTER_REQUEST_SUCCESS = 'REGISTER_REQUEST_SUCCESS';
export const REGISTER_SET_SUBMITTED = 'REGISTER_SET_SUBMITTED';

export const REGISTER_RESEND_EMAIL_REQUEST = 'REGISTER_RESEND_EMAIL_REQUEST';
export const REGISTER_RESEND_EMAIL_REQUEST_FAILURE = 'REGISTER_RESEND_EMAIL_REQUEST_FAILURE';
export const REGISTER_RESEND_EMAIL_REQUEST_SUCCESS = 'REGISTER_RESEND_EMAIL_REQUEST_SUCCESS';

export const REGISTER_EMPLOYEE_REQUEST = 'REGISTER_EMPLOYEE_REQUEST';
export const REGISTER_EMPLOYEE_REQUEST_FAILURE = 'REGISTER_EMPLOYEE_REQUEST_FAILURE';
export const REGISTER_EMPLOYEE_REQUEST_SUCCESS = 'REGISTER_EMPLOYEE_REQUEST_SUCCESS';

export const RESET_FORGOT_STATE = 'RESET_FORGOT_STATE';

export const RESET_PASSWORD_REQUEST = 'RESET_PASSWORD_REQUEST';
export const RESET_PASSWORD_REQUEST_FAILURE = 'RESET_PASSWORD_REQUEST_FAILURE';
export const RESET_PASSWORD_REQUEST_SUCCESS = 'RESET_PASSWORD_REQUEST_SUCCESS';

export const SEND_FALLBACK_MFA_CODE_REQUEST = 'SEND_FALLBACK_MFA_CODE_REQUEST';
export const SEND_FALLBACK_MFA_CODE_REQUEST_FAILURE = 'SEND_FALLBACK_MFA_CODE_REQUEST_FAILURE';
export const SEND_FALLBACK_MFA_CODE_REQUEST_SUCCESS = 'SEND_FALLBACK_MFA_CODE_REQUEST_SUCCESS';

export const UPDATE_ACCESS_TOKEN = 'UPDATE_ACCESS_TOKEN';

export const UPDATE_PASSWORD_REQUEST = 'UPDATE_PASSWORD_REQUEST';
export const UPDATE_PASSWORD_REQUEST_FAILURE = 'UPDATE_PASSWORD_REQUEST_FAILURE';
export const UPDATE_PASSWORD_REQUEST_SUCCESS = 'UPDATE_PASSWORD_REQUEST_SUCCESS';

export const UPDATE_USER_LAST_ACTIVE_TIMESHEET_REQUEST = 'UPDATE_USER_LAST_ACTIVE_TIMESHEET_REQUEST';
export const UPDATE_USER_LAST_ACTIVE_TIMESHEET_REQUEST_FAILURE = 'UPDATE_USER_LAST_ACTIVE_TIMESHEET_REQUEST_FAILURE';
export const UPDATE_USER_LAST_ACTIVE_TIMESHEET_REQUEST_SUCCESS = 'UPDATE_USER_LAST_ACTIVE_TIMESHEET_REQUEST_SUCCESS';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_REQUEST_FAILURE = 'UPDATE_USER_REQUEST_FAILURE';
export const UPDATE_USER_REQUEST_SUCCESS = 'UPDATE_USER_REQUEST_SUCCESS';

export const VALIDATE_RESET_TOKEN_REQUEST = 'VALIDATE_RESET_TOKEN_REQUEST';
export const VALIDATE_RESET_TOKEN_REQUEST_FAILURE = 'VALIDATE_RESET_TOKEN_REQUEST_FAILURE';
export const VALIDATE_RESET_TOKEN_REQUEST_SUCCESS = 'VALIDATE_RESET_TOKEN_REQUEST_SUCCESS';

export const VERIFY_MFA_REQUEST = 'VERIFY_MFA_REQUEST';
export const VERIFY_MFA_REQUEST_FAILURE = 'VERIFY_MFA_REQUEST_FAILURE';
export const VERIFY_MFA_REQUEST_SUCCESS = 'VERIFY_MFA_REQUEST_SUCCESS';

export const VERIFY_USER_REQUEST = 'VERIFY_USER_REQUEST';
export const VERIFY_USER_REQUEST_FAILURE = 'VERIFY_USER_REQUEST_FAILURE';
export const VERIFY_USER_REQUEST_SUCCESS = 'VERIFY_USER_REQUEST_SUCCESS';
